"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tpcBff = void 0;
const axios_1 = __importDefault(require("axios"));
const instance_1 = require("./instance");
const TPC_BFF = "tpcBff";
(0, instance_1.setInstance)(TPC_BFF, axios_1.default.create({
    baseURL: "https://tsaprecheckbyclear-uat.tsa.dhs.gov/v1/tpc-enrollment-bff",
}));
const tpcBff = (config, options) => (0, instance_1.getService)(TPC_BFF, config, options);
exports.tpcBff = tpcBff;
//# sourceMappingURL=index.js.map